import { render, staticRenderFns } from "./AddressBookDrawer.vue?vue&type=template&id=8ca43446&scoped=true"
import script from "./AddressBookDrawer.vue?vue&type=script&lang=js"
export * from "./AddressBookDrawer.vue?vue&type=script&lang=js"
import style0 from "./AddressBookDrawer.vue?vue&type=style&index=0&id=8ca43446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca43446",
  null
  
)

export default component.exports